export const supportNav = [
  { title: 'Contact Us', slug: '/support/contact-us/' },
  { title: 'Schedule a Meeting', slug: '/support/schedule-meeting/' }
]

export const brandDesignNav = [
  { title: 'For Organization', slug: '/brand-design/organizations/' },
  { title: 'For Individual', slug: '/brand-design/personal/' },
  { title: 'Event Branding', slug: '/brand-design/event-branding/' }
]

export const brandServices = [
  'brand-design',
  'brand-design/organizations',
  'brand-design/personal',
  'brand-design/event-branding'
]

/**
 * Filter posts by date. Feature dates will be fitered
 * When used, make sure you run a cronejob each day to show schaduled content. See docs
 *
 * @param {posts} object
 */
export const byDate = posts => {
  const now = Date.now()
  return posts.filter(post => Date.parse(post.date) <= now)
}

/**
 * filter posts by category.
 *
 * @param {posts} object
 * @param {title} string
 * @param {contentType} string
 */
export const byCategory = (posts, title, contentType) => {
  const byCategory = post =>
    post.categories &&
    post.categories.filter(cat => cat.category === title).length
  return contentType === 'pages' ? posts : posts.filter(byCategory)
}
